import React, { useEffect, useMemo, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import ReactHtmlParserComponent from "../HtmlRenderer/ReactHtmlParserComponent";
import { performGetRequest } from "../../services/apiServices/AxiosUtils";
import { URLS } from "../../services/apiServices/service";

const pageWrapStyle = {
  maxWidth: "1120px",
  width: "calc(100% - 48px)",
  margin: "0 auto",
  padding: "48px 0",
};

const titleStyle = {
  fontFamily: "GT Super Text",
  fontWeight: 700,
  fontSize: "42px",
  lineHeight: 1.15,
  margin: "0 0 24px",
  color: "#111",
};

const DESCRIPTION_ONLY_PATHS = new Set([
  "/about",
  "/constitution-bench",
  "/jaldilab/projects",
  "/jaldilab/notes-from-field",
  "/jaldi-portal",
  "/jaldi-portal/judicial-vacancy",
]);

const CmsPageOverride = ({ children }) => {
  const location = useLocation();
  const fullPath = useMemo(
    () => `${location.pathname}${location.search || ""}`,
    [location.pathname, location.search]
  );
  const normalizedPath = useMemo(
    () =>
      location.pathname.length > 1
        ? location.pathname.replace(/\/+$/, "")
        : location.pathname,
    [location.pathname]
  );
  const [override, setOverride] = useState(null);

  useEffect(() => {
    let mounted = true;
    setOverride(null);

    if (DESCRIPTION_ONLY_PATHS.has(normalizedPath)) {
      return () => {
        mounted = false;
      };
    }

    performGetRequest(
      `${URLS.PAGE_CONTENT_OVERRIDE}?path=${encodeURIComponent(fullPath)}`
    )
      .then((res) => {
        if (!mounted) return;
        const data = res?.data?.data;
        setOverride(data?.is_active && data?.content ? data : null);
      })
      .catch(() => {
        if (mounted) setOverride(null);
      });

    return () => {
      mounted = false;
    };
  }, [fullPath, normalizedPath]);

  if (!override?.content) {
    return <>{children}</>;
  }

  return (
    <Box sx={pageWrapStyle}>
      {override.show_title && override.title ? (
        <Typography component="h1" sx={titleStyle}>
          {override.title}
        </Typography>
      ) : null}
      <ReactHtmlParserComponent htmlString={override.content} />
    </Box>
  );
};

export default CmsPageOverride;
